export default "__VITE_ASSET__CdbL0eXW__"